import React from "react";
import { Link } from "react-router-dom";
import { History, Target, Eye, ArrowRight } from "lucide-react";
import "./app1.css";

import officeImg1 from "../assets/assets/hero-developers-bg.jpg";
import officeImg2 from "../assets/assets/edutech.jpg";

const App1 = () => {
  return (
    <section className="about-section-v2">
      <div className="about-middle-wrapper">
        {/* 2-Column Main Layout matching Image 1 Design */}
        <div className="about-img1-main-grid">
          {/* Left Column: Category, Title, Text Matter & Gradient Pill Button */}
          <div className="about-img1-left-col">
            <span className="about-img1-category">About Us</span>
            <h2 className="about-img1-title">
              Empowering Innovation Through Technology
            </h2>
            <div className="about-img1-desc">
              <p>
                PINKMOON Technologies is an innovative global IT consulting firm
                committed to delivering next-generation digital solutions that empower
                businesses to innovate, transform, and excel. Established in 2022
                as a self-funded venture.
              </p>
              <p>
                Headquartered in Vijayawada and Hyderabad, India, with an onshore
                business office in Stamford, USA, PINKMOON offers a comprehensive
                portfolio of IT services, product development, and consulting
                solutions. We maintain a strong client presence across global markets.
              </p>
            </div>

            <Link to="/about" className="about-know-more-link">
              <span>Know More</span>
              <span className="know-more-arrow">↗</span>
            </Link>
          </div>

          {/* Right Column: Main Rounded Photo Card with Overlapping Floating Avatar Card (Image 1 Style) */}
          <div className="about-img1-right-col">
            <div className="about-img1-main-card">
              <img
                src={officeImg1}
                alt="Pinkmoon Digital Solutions"
                className="about-img1-main-photo"
              />

              {/* Floating Avatar Card on Bottom-Right with Organic Curve matching Image 1 */}
              <div className="about-img1-floating-avatar-card">
                <img
                  src={officeImg2}
                  alt="Pinkmoon Team Portrait"
                  className="about-img1-avatar-photo"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Bottom 3 Feature Cards (History, Mission, Vision) */}
        <div className="about-cards-grid">
          <div className="about-feature-card">
            <div className="about-card-icon-wrapper icon-blue">
              <History size={24} />
            </div>
            <h3 className="about-card-title">Our History</h3>
            <p className="about-card-text">
              Established in 2022, PINKMOON has grown as a visionary and reliable
              software engineering partner for world-class brands across global markets.
            </p>
          </div>

          <div className="about-feature-card">
            <div className="about-card-icon-wrapper icon-orange">
              <Target size={24} />
            </div>
            <h3 className="about-card-title">Our Mission</h3>
            <p className="about-card-text">
              To deliver cutting-edge IT consulting, product development, and digital
              transformation solutions that empower businesses to innovate and excel.
            </p>
          </div>

          <div className="about-feature-card">
            <div className="about-card-icon-wrapper icon-pink">
              <Eye size={24} />
            </div>
            <h3 className="about-card-title">Our Vision</h3>
            <p className="about-card-text">
              To be a global leader in software engineering and IT consulting, driving
              digital transformation with next-generation technology worldwide.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default App1;